import React, { Component } from 'react'
import CommonFetch from '../../../requests/commonFetch'

const confirmCode = props => {
    const translation = JSON.parse(localStorage.translation)[
        localStorage.language
    ]

    let {
        phoneCode,
        confirmPhone,
        handlePhoneNumberChange,
        dataProtection,
    } = props

    let formData = new FormData()
    formData.append('verification_code', phoneCode)

    CommonFetch({
        path: 'ui/investor_settings/post_confirmphone',
        method: 'POST',
        data: formData,
    }).then(data => {
        if (data.success) {
            if (confirmPhone) {
                handlePhoneNumberChange(['confirmPhone', 'phoneCode'])
            }
            dataProtection('update')
            console.log(data)
        }
    })
}

export default confirmCode
